import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import DateTimeField from 'components/DateTimeField';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import * as validators from 'utils/validators';
import { injectIntl } from 'react-intl';

function getLastWeek() {
  var today = new Date();
  var lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7, today.getHours(), today.getMinutes());
  return lastWeek;
}
class InvoiceSearch extends Component {
  render() {
    let {handleSubmit, onSearch, fetching, intl} = this.props;
    const t = (id) => intl.formatMessage({ id });
    return (<form onSubmit={handleSubmit(onSearch)}>
      <Row>
      <Col md={1}>
          <label>{t('search.createdBetween')}</label>
          <Field
            name="created_at_min"
            component={DateTimeField}
          />
        </Col>
        <Col md={1}>
          <label>&nbsp;</label>
          <Field
            name="created_at_max"
            component={DateTimeField}
          />

        </Col>
        <Col md={1}>
          <label>{t('search.modifiedBetween')}</label>
          <Field
            name="updated_at_min"
            component={DateTimeField}
          />
        </Col>
        <Col md={1}>
         <label>&nbsp;</label>
          <Field
            name="updated_at_max"
            component={DateTimeField}
          />

        </Col>
        <Col md={1}>
          <label>{t('search.orderNumber')}</label>
          <div>
            <Field className="form-control" name="name" component="input" type="text" placeholder="1515"/>
          </div>
        </Col>
        <Col md={1}>
          <label>{t('search.invoiceNumber')}</label>
          <div>
            <Field className="form-control" name="invoice_number" component="input" type="text" placeholder="123"/>
          </div>
        </Col>
        <Col md={1}>
          <label>{t('search.refundNumber')}</label>
          <div>
            <Field className="form-control" name="storno_number" component="input" type="text" placeholder="123"/>
          </div>
        </Col>
        <Col md={2}>
          <label>{t('search.customer')}</label>
          <div>
            <Field className="form-control" name="customer" component="input" type="text" placeholder="John Doe"/>
          </div>
        </Col>
        <Col md={1}>
          <label>{t('search.payment')}</label>{" "}
            <Field className="form-control" name="financial_status" component="select">
              <option value="any">{t('search.any')}</option>
              <option value="authorized">{t('search.authorized')}</option>
              <option value="pending">{t('search.pending')}</option>
              <option value="paid">{t('search.paid')}</option>
              <option value="partially_paid">{t('search.partiallyPaid')}</option>
              <option value="refunded">{t('search.refunded')}</option>
              <option value="voided">{t('search.voided')}</option>
              <option value="partially_refunded">{t('search.partiallyRefunded')}</option>
              <option value="unpaid">{t('search.unpaid')}</option>
            </Field>
        </Col>
        <Col md={1}>

          <label>{t('search.fulfillment')}</label>{" "}
          <Field className="form-control" name="fulfillment_status" component="select">
            <option value="any">{t('search.any')}</option>
            <option value="shipped">{t('search.fulfilled')}</option>
            <option value="partial">{t('search.partial')}</option>
            <option value="unshipped">{t('search.unfulfilled')}</option>
          </Field>
        </Col>
        <Col md={1}>
          <label>&nbsp;</label>
          <button disabled={fetching} type="submit" className="form-control" style={{ cursor: 'pointer', textAlign: 'center', whiteSpace: 'nowrap' }}><i className={fetching ? "fa fa-spin fa-spinner": "fa fa-search"}></i>&nbsp;{fetching ? t('search.loading') : t('search.search')}</button>
        </Col>

      </Row>
    </form>);
  }
}


let InvoiceSearchForm = reduxForm({
  form: 'InvoiceSearchForm',
  destroyOnUnmount: true
})(injectIntl(InvoiceSearch));
const selector = formValueSelector('InvoiceSearchForm');

InvoiceSearchForm = connect(state => {
  return {
    filter: { ...state.form.InvoiceSearchForm }
  }
})(InvoiceSearchForm)

export default InvoiceSearchForm;



// WEBPACK FOOTER //
// app/components/dashboard/InvoiceSearchForm.jsx